export default __webpack_public_path__ + "static/media/thumbnail.52d5a620.png";